import {Component, OnInit, ViewChild} from '@angular/core';
import {ConfiguracoesMiaService} from "../../services/configuracoes-mia.service";
import {NgForm} from "@angular/forms";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {NotificacoesService} from "../../services/notificacoes.service";
import {
  FreeTrialConfirmationModalComponent
} from "../../free-trial-confirmation-modal/free-trial-confirmation-modal.component";
import { trigger, transition, style, animate } from '@angular/animations';
import {Router} from "@angular/router";
import {AutorizacaoService} from "../../services/autorizacao.service";
import {MiaV3Service} from "../../services/mia-v3.service";

declare var moment;

@Component({
  selector: 'app-tela-config-atendente-virtual',
  templateUrl: './tela-config-atendente-virtual.component.html',
  styleUrls: ['./tela-config-atendente-virtual.component.scss']
})
export class TelaConfigAtendenteVirtualComponent implements OnInit {
  @ViewChild('frm') frm: NgForm;

  
  public configuracoes = {
    nome: '',
    status: 'DESATIVADA',
    telefonesTeste: '',
    modelo: '',
    comportamentoForaDoEscopo: '',
    responderSobreProdutos: false,
    typebotConfigurado: false,
    escalarParaAtendente: true,
    mensagemEscalacao: '',
    tempoPausaMia: 1800,
    recuperarCarrinho: false,
    tempoRecuperarCarrinho: 20 * 60,
    dataInicioTrial: null,
    usarFluxoTypebot: false,
    idFluxoTypebot: null,
    idFluxoTypebotWhatsapp: null,
    idFluxoTypebotInstagram: null,
    publicIdFluxoInstagram: null,
    publicIdFluxoWhatsapp: null,
    modeloIaV3: '',
    usarMiaV3: false,
    carrinhoMiaV3: false,
  }
  // seleção de modelo da Mia V3: visível só para admins do meucardápio
  ehAdminMeuCardapio = false;
  // checklist de ativação da Mia V3 (número cloud, recurso, flags, serviço)
  statusMiaV3: any = null;
  modelosIa = [
    { valor: '', rotulo: 'Padrão do serviço (Claude Sonnet 5)' },
    { valor: 'claude-sonnet-5', rotulo: 'Claude Sonnet 5 — $3/$15 MTok' },
    { valor: 'claude-haiku-4-5', rotulo: 'Claude Haiku 4.5 — $1/$5 MTok (econômico)' },
    { valor: 'claude-opus-5', rotulo: 'Claude Opus 5 — $5/$25 MTok (mais capaz)' },
    { valor: 'gpt-5.6-luna', rotulo: 'GPT-5.6 Luna — $0,20/$1,20 MTok (OpenAI, econômico)' },
    { valor: 'gpt-5.6-terra', rotulo: 'GPT-5.6 Terra — $2/$12 MTok (OpenAI, balanceado)' },
    { valor: 'deepseek-v4-flash', rotulo: 'DeepSeek V4 Flash — $0,14/$0,28 MTok (Responses API, reasoning max)' },
  ];
  msgSucesso = '';
  // blocos de ajuda começam fechados: quem entra aqui vem configurar, não ler
  mostrarRecursos = false;
  mostrarFluxoPadrao = false;
  telefones: Array<string> = [];
  novoTelefone = '';

  // a tela é dividida em abas: cada uma é uma decisão diferente do lojista
  abaAtiva = 'status';
  abas = [
    {chave: 'status', rotulo: 'Status & Geral', icone: 'fa-cog', exigeMiaLigada: false, selo: ''},
    {chave: 'comportamento', rotulo: 'Comportamento', icone: 'fa-sliders-h', exigeMiaLigada: true, selo: ''},
    {chave: 'carrinho', rotulo: 'Recuperação de Carrinho', icone: 'fa-shopping-basket', exigeMiaLigada: true, selo: 'Crucial'},
    {chave: 'fluxo', rotulo: 'Fluxo de Conversas', icone: 'fa-layer-group', exigeMiaLigada: true, selo: ''},
  ];
  empresa: any;
  comportamentoForaDoEscopoEnum: string;
  notificacao: any;

  @ViewChild('freeTrialConfirmationModal', {static: false}) freeTrialConfirmationModal: FreeTrialConfirmationModalComponent;

  /*
  planosMia: PlanoMia[] = [
    {
      nome: "Básico",
      modelo: 'Basico',
      icone: "fas fa-circle",
      preco: 0,
      billingPeriod: 'mês',
      caracteristicas: [
        {texto: "Respostas da IA são dinâmicas", disponivel: true},
        {texto: "Memória limitada à última mensagem", disponivel: true},
        {texto: "Responde dúvidas dos clientes", disponivel: true},
        {texto: "Personalizar nome da Mia", disponivel: false},
        {texto: "Conhecimentos extras", disponivel: false},
        {texto: "Sem custo", disponivel: false}
      ],
      testeGratis: false
    },
    {
      nome: "Intermediário",
      modelo: 'Intermediario',
      icone: "fa fa-robot",
      preco: 49.90,
      billingPeriod: 'mês',
      caracteristicas: [
        {texto: "Respostas da IA são dinâmicas", disponivel: true},
        {texto: "Responde dúvidas dos clientes", disponivel: true},
        {texto: "Personalizar Nome da Mia", disponivel: true},
        {texto: "Memória das últimas 5 mensagens", disponivel: true},
        {texto: "Respostas mais contextuais", disponivel: true},
        {texto: "Conhecimentos extras", disponivel: true}
      ],
      testeGratis: true
    },
    {
      nome: "Ultra Inteligente (GPT-4)",
      preco: 99.90,
      icone: "fas fa-lightbulb",
      modelo: 'Avancado',
      billingPeriod: 'mês',
      caracteristicas: [
        {texto: "Respostas da IA são dinâmicas", disponivel: true},
        {texto: "Personalizar Nome da Mia", disponivel: true},
        {texto: "Memória de toda sessão de conversa", disponivel: true},
        {texto: "Entende perguntas mais complexas", disponivel: true},
        {texto: "Respostas mais contextuais", disponivel: true},
        {texto: "Conhecimentos extras", disponivel: true}
      ],
      testeGratis: true
    }
  ];
  planoEscolhido: any = {};
   */
  criandoFluxosTypebot: boolean;

  constructor(private configuracoesMiaService: ConfiguracoesMiaService, private constantsService: ConstantsService,
              private notificacoesService: NotificacoesService, private router: Router,
              private autorizacaoService: AutorizacaoService, private miaV3Service: MiaV3Service) { }

  ngOnInit(): void {
      const usuario: any = this.autorizacaoService.getUser() || {};
      this.ehAdminMeuCardapio = !!(usuario.admin || usuario.superadmin);
      if (this.ehAdminMeuCardapio) {
        // tudo da Mia V3 (toggles, modelo, checklist, widget) mora numa aba
        // própria — a aba 1 fica só com o que o lojista decide
        this.abas = [...this.abas,
          {chave: 'miav3', rotulo: 'Mia V3', icone: 'fa-flask', exigeMiaLigada: false, selo: 'admin'}];
        this.carregueStatusMiaV3();
      }
      this.notificacoesService.carregue('Carrinho Abandonado').then((notificacao) => {
        if( !notificacao ) {
          notificacao = {
            ativada: true,
            fazerPreview: true
          };
        }

        this.notificacao = notificacao;
        //carrega a configuracao
        this.configuracoesMiaService.obtenhaConfiguracoes().then((configuracoes) => {
            this.configuracoes = configuracoes;
            // coluna nova + tinyint do MySQL: sem valor explícito o handoff fica
            // ligado (senão a tela salvaria "não escalar" sem ninguém pedir)
            this.configuracoes.escalarParaAtendente =
              configuracoes.escalarParaAtendente === undefined || configuracoes.escalarParaAtendente === null
                ? true
                : !!configuracoes.escalarParaAtendente;
            this.configuracoes.mensagemEscalacao = configuracoes.mensagemEscalacao || '';
            this.telefones = (this.configuracoes.telefonesTeste || '')
              .split(',').map((telefone) => telefone.trim()).filter((telefone) => !!telefone);
        });

        //carrega a empresa
        this.constantsService.empresa$.subscribe((empresa) => {
            if (empresa && empresa.id) {
                this.empresa = empresa;
            }
        });
      });
  }

  //rotula o estado da Mia no cabeçalho e na barra de ações
  get estadoAtual(): { chave: string, rotulo: string } {
    if (this.configuracoes.status === 'ATIVADA') {
      return {chave: 'ativa', rotulo: 'Em Produção'};
    }

    if (this.configuracoes.status === 'MODO_TESTE') {
      return {chave: 'teste', rotulo: 'Modo Teste'};
    }

    return {chave: 'off', rotulo: 'Desligada'};
  }

  /** Com a Mia desligada, as abas de ajuste não têm efeito nenhum. */
  get miaDesligada(): boolean {
    return this.configuracoes.status === 'DESATIVADA';
  }

  selecioneAba(chave: string) {
    const aba = this.abas.find((item) => item.chave === chave);
    if (!aba || (aba.exigeMiaLigada && this.miaDesligada)) {
      return;
    }

    this.abaAtiva = chave;
  }

  /** Exemplo de número no formato aceito, usando o WhatsApp da própria loja. */
  get exemploTelefone(): string {
    const whatsapp = this.empresa && this.empresa.numeroWhatsapp && this.empresa.numeroWhatsapp.whatsapp;
    return whatsapp ? `+55${whatsapp}` : '+55DDDNÚMERO';
  }

  adicioneTelefone() {
    const telefone = (this.novoTelefone || '').replace(/[\s()\-\.]/g, '');
    if (!telefone || this.telefones.indexOf(telefone) >= 0) {
      this.novoTelefone = '';
      return;
    }

    this.telefones = [...this.telefones, telefone];
    this.novoTelefone = '';
  }

  removaTelefone(telefone: string) {
    this.telefones = this.telefones.filter((item) => item !== telefone);
  }

  carregueStatusMiaV3() {
    this.configuracoesMiaService.obtenhaStatusMiaV3()
      .then((status: any) => {
        this.statusMiaV3 = status;
        // link do widget só existe com o recurso ativo (as rotas /miav3 exigem)
        if (status?.recursoMiaV3Ativo && !this.widgetUrl) this.carregueLinkWidget();
      })
      .catch(() => this.statusMiaV3 = null);
  }

  // ==== widget de demonstração (link público por token) ====
  widgetUrl = '';
  widgetErro = '';
  widgetCarregando = false;
  widgetCopiado = false;
  regenerandoWidget = false;

  carregueLinkWidget() {
    this.widgetCarregando = true;
    this.widgetErro = '';
    this.miaV3Service.obtenhaLinkWidget()
      .then((resposta: any) => {
        this.widgetUrl = resposta?.url || '';
        if (!this.widgetUrl) this.widgetErro = resposta?.erro || 'Não consegui montar o link do widget.';
      })
      .catch(() => this.widgetErro = 'Não consegui carregar o link do widget.')
      .then(() => this.widgetCarregando = false);
  }

  copieLinkWidget() {
    if (!this.widgetUrl || !navigator.clipboard) return;
    navigator.clipboard.writeText(this.widgetUrl).then(() => {
      this.widgetCopiado = true;
      setTimeout(() => this.widgetCopiado = false, 2000);
    });
  }

  regenereTokenWidget() {
    if (this.regenerandoWidget) return;
    if (!confirm('Regenerar o link do widget? O link atual vai parar de funcionar na hora.')) return;

    this.regenerandoWidget = true;
    this.widgetErro = '';
    this.miaV3Service.regenereTokenWidget()
      .then((resposta: any) => {
        if (resposta?.url) this.widgetUrl = resposta.url;
        else this.widgetErro = resposta?.erro || 'Não consegui regenerar o link.';
      })
      .catch(() => this.widgetErro = 'Não consegui regenerar o link.')
      .then(() => this.regenerandoWidget = false);
  }

  /** Linhas do checklist de ativação, na ordem do pipeline. */
  get itensChecklistMiaV3(): Array<{ ok: boolean; rotulo: string; detalhe?: string }> {
    const status = this.statusMiaV3;
    if (!status) return [];
    return [
      { ok: status.telefoneCloudConectado, rotulo: 'Número conectado à API oficial (Cloud)',
        detalhe: status.numeroCloud || 'nenhum número cadastrado' },
      { ok: status.recursoMiaV3Ativo, rotulo: 'Recurso Mia V3 ativo na empresa',
        detalhe: status.recursoMiaV3Ativo ? undefined : 'ativar na Central Contratação (superadmin)' },
      { ok: status.usarMiaV3, rotulo: 'Mia V3 ligada (usarMiaV3)' },
      { ok: status.statusMia !== 'DESATIVADA' && !!status.statusMia, rotulo: 'Status da Mia',
        detalhe: status.statusMia || 'sem configuração' },
      { ok: status.servicoOnline, rotulo: 'Serviço mia-v3 no ar',
        detalhe: status.servicoOnline ? undefined : 'verifique o processo na porta 4330' },
      { ok: status.carrinhoMiaV3, rotulo: 'Carrinho conversacional (vendas)',
        detalhe: status.carrinhoMiaV3 ? undefined : 'desligado: a Mia só tira dúvidas' },
    ];
  }

  get checklistProntos(): number {
    return this.itensChecklistMiaV3.filter((item) => item.ok).length;
  }

  get checklistPercentual(): number {
    const total = this.itensChecklistMiaV3.length;
    return total ? Math.round((this.checklistProntos / total) * 100) : 0;
  }

  get checklistCompleto(): boolean {
    const total = this.itensChecklistMiaV3.length;
    return total > 0 && this.checklistProntos === total;
  }

  fechar() {

  }

  onSubmit() {
    this.msgSucesso = '';
    if( !this.configuracoes.nome ) {
      return;
    }

    //número digitado sem clicar em "Adicionar" não pode se perder no salvamento
    this.adicioneTelefone();
    this.configuracoes.telefonesTeste = this.telefones.join(",");
    this.configuracoesMiaService.salveConfiguracoes(this.configuracoes).then((configuracaoSalva) => {
      this.configuracoes = configuracaoSalva;
      this.msgSucesso = 'Salvou configurações da Mia';
      if (this.ehAdminMeuCardapio) this.carregueStatusMiaV3();
    });
  }

  formatTime(seconds: number): string {
    const duration = moment.duration(seconds, 'seconds');
    let formattedTime = '';

    if (duration.hours() > 0) {
      formattedTime += `${duration.hours()} ${this.pluralize(duration.hours(), 'hora', 'horas')} `;
    }

    if (duration.minutes() > 0 || duration.hours() > 0) {
      formattedTime += `${duration.minutes()} ${this.pluralize(duration.minutes(), 'minuto', 'minutos')} `;
    }

    if( duration.seconds() > 0 ) {
      formattedTime += `${duration.seconds()} ${this.pluralize(duration.seconds(), 'segundo', 'segundos')}`;
    }

    return formattedTime;
  }

  pluralize(quantity: number, singular: string, plural: string): string {
    return quantity === 1 ? singular : plural;
  }

  /*
  escolhiPlano(plano: PlanoMia) {
    this.freeTrialConfirmationModal.abraModal(plano);
  }
   */

  onConfirmSubscription(plano: any) {
    const configuracoesModificadas = { ...this.configuracoes };
    configuracoesModificadas.modelo = plano.modelo;

    this.configuracoesMiaService.atualizeMudouPlano(configuracoesModificadas).then( (resposta) => {
      this.configuracoes.modelo = plano.modelo;

      this.configuracoes.dataInicioTrial = new Date();

      //this.escolhendoPlano = false;
      //this.loading = false;
      this.freeTrialConfirmationModal.feche();
    });
  }

  onCancelSubscription() {
    //alert('Processo de assinatura cancelado');
    //this.router.navigate(['/home']);
  }

  mudarPlano() {
    //this.escolhendoPlano = true;
  }

  voltar() {
    //this.escolhendoPlano = false;
  }

  onUsarFluxoTypebotChange($event: any) {
    if (!this.configuracoes.usarFluxoTypebot) {
      return;
    }
  }

  editarFluxoTypebot(tipoDeFluxo: string, nomeFluxo: string) {
    if( tipoDeFluxo === 'whatsapp' ) {
      this.router.navigateByUrl('/admin/chatbot/editor-fluxo?id=' + 
        this.configuracoes.idFluxoTypebotWhatsapp + '&nome=' + nomeFluxo +
        '&publicId=' + this.configuracoes.publicIdFluxoWhatsapp);
    } else if( tipoDeFluxo === 'instagram' ) {
      this.router.navigateByUrl('/admin/chatbot/editor-fluxo?id=' + this.configuracoes.idFluxoTypebotInstagram + '&nome=' + nomeFluxo +
        '&publicId=' + this.configuracoes.publicIdFluxoInstagram);
    }
  }

  abrirTelaConfigTypebot() {
    this.router.navigate(['/admin/chatbot/config-typebot'], {
      queryParams: {
        configuracoes: JSON.stringify(this.configuracoes)
      }
    });
  }
}
